import React, { useEffect, useState } from 'react';
import StatCard from '../components/StatCard';
import { fetchDashboardStats } from '../lib/statsService';
import type { StatCardData } from '../types';
import { logger } from '../lib/logger';

const Dashboard: React.FC = () => {
  const [stats1, setStats1] = useState<StatCardData[]>([]);
  const [stats2, setStats2] = useState<StatCardData[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { row1, row2 } = await fetchDashboardStats();
        setStats1(row1);
        setStats2(row2);
      } catch (err) {
        logger.error('load_dashboard', 'Dashboard', { error: String(err) });
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center py-20">
        <div className="w-8 h-8 border-2 border-[#00244F]/20 border-t-[#00244F] rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {stats1.map((stat, i) => (
          <StatCard key={i} data={stat} />
        ))}
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {stats2.map((stat, i) => (
          <StatCard key={i} data={stat} />
        ))}
      </div>
    </div>
  );
};

export default Dashboard;
